import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { useMemo } from "react";
import { getSingleJobDesc, getSingleOpenJob } from "../../../../Redux/Reducers/JobReducer";

const RecommendedJobsCompo = () => {
  const navigate = useNavigate();
  const jobs = useSelector((state) => state?.jobs?.allJobs);
  const otherJobs = jobs?.open_jobs || [];
  const JobPreferences =
    useSelector((state) => state?.ProfileArray?.professionaProfile) || {};
  const ApplicantsPage = useSelector((state) => state?.jobs?.appliedJobs) || {};
  const appliedJobs = ApplicantsPage?.appliedJobs || [];
  const location = useLocation();
  const dispatch = useDispatch();

  const getRecommendedJobs = useMemo(() => {
    if (!JobPreferences || !otherJobs?.length) return otherJobs;

    let recommendedJobs = [];

    // Priority 1: Match by preferred_role
    if (JobPreferences?.preferred_role) {
      recommendedJobs = otherJobs?.filter(
        (job) =>
          job?.role?.toLowerCase() ===
          JobPreferences?.preferred_role.toLowerCase()
      );
    }

    // Priority 2: Match by preferred_location
    if (recommendedJobs?.length < 10 && JobPreferences?.preferred_location) {
      const locationMatches = otherJobs.filter(
        (job) =>
          !recommendedJobs.includes(job) &&
          job?.location
            ?.toLowerCase()
            .includes(JobPreferences?.preferred_location.toLowerCase())
      );
      recommendedJobs = recommendedJobs?.concat(locationMatches);
    }

    // Priority 3: Match by preferred_work_mode
    if (recommendedJobs?.length < 10 && JobPreferences.preferred_work_mode) {
      const workModeMatches = otherJobs.filter(
        (job) =>
          !recommendedJobs.includes(job) &&
          job?.work_mode?.toLowerCase() ===
            JobPreferences?.preferred_work_mode.toLowerCase()
      );
      recommendedJobs = recommendedJobs?.concat(workModeMatches);
    }

    // Priority 4: Match by tag_name
    if (recommendedJobs?.length < 10 && JobPreferences.tag_name) {
      const tagNameMatches = otherJobs?.filter(
        (job) =>
          !recommendedJobs.includes(job) &&
          job?.mode?.toLowerCase() === JobPreferences.tag_name.toLowerCase()
      );
      recommendedJobs = recommendedJobs.concat(tagNameMatches);
    }

    // Fill remaining slots
    if (recommendedJobs.length < 10) {
      const remainingJobs = otherJobs?.filter(
        (job) => !recommendedJobs.includes(job)
      );
      recommendedJobs = recommendedJobs.concat(remainingJobs);
    }

    // Remove applied jobs
    const appliedJobIds = new Set(appliedJobs?.map((job) => job?.job_id));
    recommendedJobs = recommendedJobs?.filter(
      (job) => !appliedJobIds.has(job?.id)
    );

    // Return first 10 jobs (or all if less than 10)
    return recommendedJobs?.slice(0, 10);
  }, [otherJobs, JobPreferences, appliedJobs]);

  const handleJobClick = (jobId) => {
    // dispatch(getSingleJobDesc(jobId));
    navigate(`/job-description/${jobId}`);
  };

  const renderJobLogo = (job) => {
    return job?.company_logo ? (
      <img
        src={job?.company_logo}
        alt={`${job?.company_name} logo`}
        style={{
          width: "60px",
          height: "60px",
          objectFit: "contain",
          borderRadius: "4px",
        }}
      />
    ) : (
      <Box
        sx={{
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f0f0f0",
          borderRadius: "4px",
          color: "#666",
          fontSize: "16px",
          fontWeight: "bold",
        }}
      >
        {job?.company_name?.[0]?.toUpperCase() || "C"}
      </Box>
    );
  };

  return (
    <Box className="sidefeed-box job-openings-box my-2">
      <div className="sidefeed-titles d-flex justify-content-between align-items-center mb-2">
        <Typography variant="subtitle1" fontWeight="bold">
          Jobs For You
        </Typography>
      </div>

      {getRecommendedJobs?.length > 0 ? (
        getRecommendedJobs?.map((job, index) => (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            p={2}
            mt={1}
            borderRadius={2}
            border={"1px solid lightgray"}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              {renderJobLogo(job)}
              <Button
                variant="text"
                size="small"
                onClick={() => handleJobClick(job?.id)}
                sx={{
                  mt: "4px",
                  py: 0.5,
                  px: 2,
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                }}
              >
                View Job
              </Button>
            </Box>

            <Box ml={2}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                color={"#0044C6"}
                fontSize={"16px"}
              >
                {job?.role || "Position Not Specified"}
              </Typography>
              <Typography variant="body2" sx={{ color: "#666" }}>
                Company Name: {job?.company_name || "Company Not Specified"}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ color: "#666" }}
              >
                Location: {job?.location || "Location Not Specified"}
              </Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Box sx={{ textAlign: "center", p: 3 }}>
          <Typography variant="body2" color="textSecondary">
            No Recommended Jobs found
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default RecommendedJobsCompo;
